import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../../../styles/dashboardTheme.css";
import "../../../../styles/managementTheme.css";
import "../styles/tabs.css";
import "../styles/adminDashboard.css";
import useAdminDashboard from "../hooks/useAdminDashboard";
import SecurityTab from "../components/SecurityTab";
import OperativoTab from "../components/OperativoTab";
import AcademicTab from "../components/AcademicTab";
import StudentsTab from "../components/StudentsTab";
import DeliveriesTab from "../components/DeliveriesTab";
import FinancialTab from "../components/FinancialTab";
import ContractsTab from "../components/ContractsTab";

const formatNumber = (value) => {
  if (value === null || value === undefined) return "0";
  const num = Number(value);
  if (Number.isNaN(num)) return value;
  return num.toLocaleString("es-EC");
};

const accentMap = {
  blue: { bg: "#e0ecff", fg: "#1d4ed8" },
  violet: { bg: "#ebe9ff", fg: "#6d28d9" },
  green: { bg: "#e5f8f2", fg: "#0f766e" },
  amber: { bg: "#fff4e0", fg: "#c2410c" },
  aqua: { bg: "#e0f7ff", fg: "#0ea5e9" },
  coral: { bg: "#ffe7e2", fg: "#dc2626" },
};

export default function AdministradorDashboard() {
  const {
    filters,
    data,
    summary,
    loading,
    error,
    centros,
    cursos,
    promociones,
    handleChange,
    fetchDashboard,
    resetFilters,
  } = useAdminDashboard();

  const [activeTab, setActiveTab] = useState("seguridad");
  const [readyTab, setReadyTab] = useState(null);

  useEffect(() => {
    if (activeTab) {
      requestAnimationFrame(() => setReadyTab(activeTab));
    }

  }, [activeTab]);
  useEffect(() => {
    fetchDashboard();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();
    fetchDashboard();
  };

  const handleTabClick = (key) => {
    setActiveTab(key);
    if (key === "seguridad") {
      fetchDashboard();
    }
  };

  const seguridad = data?.seguridad || { kpis: [], recentAccess: [], alerts: [] };
  const operativo = data?.operativo || { kpis: [], funnel: [], conversions: [], visitas: [] };
  const academico = data?.academico || { kpis: [], ocupacion: [], proximas: [] };
  const estudiantes = data?.estudiantes || { kpis: [], documentosPendientes: [], riesgos: [] };
  const entregables = data?.entregables || { kpis: [], estudiantes: [] };
  const financiero = data?.financiero || { kpis: [], cobranzaDia: [], metodoPago: [], facturas: [] };
  const contratos = data?.contratos || { kpis: [], sinContrato: [], recientes: [] };

  return (
    <div className="dashboard-page management-page dashboardAdmin container-fluid py-4">
      <div className="card border-0 shadow-sm dashboard-hero mb-3">
        <div className="card-body d-flex flex-column gap-2 gap-md-3">
          <div className="d-flex flex-wrap justify-content-between align-items-center gap-2">
            <div>
              <p className="dashboard-eyebrow mb-1">Administrador</p>
              <h4 className="dashboard-title mb-0">Dashboard</h4>
              <div className="admin-hero-meta">
                <small className="text-muted">
                  {summary.lastUpdate ? `Actualizado ${new Date(summary.lastUpdate).toLocaleString()}` : "Sincroniza para ver datos"}
                </small>
                <button className="btn-filter-reset" type="button" onClick={resetFilters}>
                  Limpiar filtros
                </button>
              </div>
            </div>
          </div>

          <form className="row gy-2 gx-3 align-items-end" onSubmit={onSubmit}>
            <div className="col-12 col-md-3">
              <label className="form-label mb-1">Centro</label>
              <select
                className="form-select"
                value={filters.centro_id}
                onChange={(e) => handleChange("centro_id", e.target.value)}
              >
                <option value="">Todos</option>
                {centros.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.alias || c.nombre || `Centro ${c.id}`}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-12 col-md-3">
              <label className="form-label mb-1">Curso</label>
              <select
                className="form-select"
                value={filters.curso_id}
                onChange={(e) => handleChange("curso_id", e.target.value)}
                disabled={!filters.centro_id}
              >
                <option value="">Todos</option>
                {cursos.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.nombre || `Curso ${c.id}`}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-12 col-md-3">
              <label className="form-label mb-1">Promocion</label>
              <select
                className="form-select"
                value={filters.promocion_id}
                onChange={(e) => handleChange("promocion_id", e.target.value)}
                disabled={!filters.curso_id}
              >
                <option value="">Todas</option>
                {promociones.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.numero_promocion || p.nombre || `Promo ${p.id}`}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-6 col-md-1">
              <label className="form-label mb-1">Desde</label>
              <input
                type="date"
                className="form-control"
                value={filters.startDate}
                onChange={(e) => handleChange("startDate", e.target.value)}
              />
            </div>
            <div className="col-6 col-md-1">
              <label className="form-label mb-1">Hasta</label>
              <input
                type="date"
                className="form-control"
                value={filters.endDate}
                onChange={(e) => handleChange("endDate", e.target.value)}
              />
            </div>
            <div className="col-12 col-md-1 d-flex align-items-end">
              <button className="btn btn-primary w-100" type="submit" disabled={loading}>
                <i className="bi bi-arrow-repeat me-1" />
                {loading ? "Aplicando..." : "Aplicar"}
              </button>
            </div>
          </form>
        </div>
      </div>

      {error && (
        <div className="alert alert-danger d-flex align-items-center gap-2">
          <i className="bi bi-exclamation-triangle" />
          <span>{error}</span>
        </div>
      )}

      <div className="row g-3 admin-kpi-row">
        {summary.kpis.map((kpi) => (
          <div className="col-12 col-sm-6 col-lg-4 col-xxl-2" key={kpi.key}>
            <div className="admin-kpi-card h-100">
              <div className="admin-kpi-body">
                <span
                  className="admin-kpi-icon"
                  style={{
                    backgroundColor: accentMap[kpi.accent]?.bg || "#e5e7eb",
                    color: accentMap[kpi.accent]?.fg || "#0f172a",
                  }}
                >
                  <i className={`bi ${kpi.icon || "bi-circle"} me-0`}></i>
                </span>
                <div className="admin-kpi-text">
                  <p className="admin-kpi-label mb-0">{kpi.label}</p>
                  <div className="admin-kpi-value">
                    {kpi.isMoney ? `$${formatNumber(kpi.value)}` : formatNumber(kpi.value)}
                  </div>
                  <div className="admin-kpi-helper">{kpi.helper}</div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="admin-tabs mb-3">
        {[
          { key: "seguridad", label: "Seguridad" },
          { key: "operativo", label: "Operativo" },
          { key: "academico", label: "Academico" },
          { key: "estudiantes", label: "Estudiantes" },
          { key: "entregables", label: "Entregables" },
          { key: "financiero", label: "Financiero" },
          { key: "contratos", label: "Contratos" },
        ].map((tab) => (
          <button
            key={tab.key}
            type="button"
            className={`admin-tab ${activeTab === tab.key ? "active" : ""}`}
            onClick={() => handleTabClick(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === "seguridad" && <SecurityTab seguridad={seguridad} />}
      {activeTab === "operativo" && <OperativoTab operativo={operativo} />}
      {activeTab === "academico" && <AcademicTab academico={academico} />}
      {activeTab === "estudiantes" && <StudentsTab estudiantes={estudiantes} />}
      {activeTab === "entregables" && <DeliveriesTab entregables={entregables} />}
      {readyTab === "financiero" && (
        <FinancialTab
          financiero={financiero}
          centros={centros}
          cursos={cursos}
          promociones={promociones}
          globalFilters={filters}
        />
      )}
      {activeTab === "contratos" && <ContractsTab contratos={contratos} />}

      {/*  {!loading && data && (
        <div className="card border-0 shadow-sm mt-4">
          <div className="card-header bg-white border-0 d-flex justify-content-between align-items-center">
            <div>
              <h6 className="mb-0">Datos en bruto</h6>
              <small className="text-muted">Respuesta directa del servicio para validar filtros</small>
            </div>
            <span className="dashboard-chip">Debug</span>
          </div>
          <div className="card-body" style={{ maxHeight: "420px", overflow: "auto" }}>
            <pre className="small mb-0">{JSON.stringify(data, null, 2)}</pre>
          </div>
        </div>
      )}  */}
    </div>
  );
}
